import React from 'react'
import { Mutation } from 'react-admin'
import { Button } from '@material-ui/core'

const options = {
  undoable: false,
  onSuccess: {
    notification: { body: 'KYC review started', level: 'info' },
    redirectTo: '/employees',
  },
  onFailure: {
    notification: { body: 'Error: starting kyc review', level: 'warning' },
  },
}

const StartKYCButton = ({ record, label, status }) => {
  const payload = record ? { id: record.id, data: { id: record.id, action: status } } : {}
  return (
    <Mutation type="UPDATE" resource="employees" payload={payload} options={options}>
      {activate => (
        <Button label="Activate" onClick={activate}>
          {label}
        </Button>
      )}
    </Mutation>
  )
}

export default StartKYCButton
